import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { DataService } from 'src/app/@core/services/data.service';
import { EcommerceInterface } from 'src/app/@core/models/site-data.model';
import * as Sentry from "@sentry/browser";
import { CommerceService } from 'src/app/@core/services/commerce.service';
import { IProductInterface } from 'src/app/@core/models/products.model';
import { Router } from '@angular/router';
import { CURRENCIES } from 'src/app/@core/data/builder/currencies.json';
import { GoogleAnalyticsService } from 'src/app/@core/services/google-analytics.service';
import { FontsService } from 'src/app/@core/services/fonts.service';


@Component({
  selector: 'app-e-commerce',
  templateUrl: './e-commerce.component.html',
  styleUrls: ['./e-commerce.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class MaterialEcommerceComponent implements OnInit, OnDestroy {
  data: EcommerceInterface;
  backgroundColor: string = '';
  categoriesFilter: string[] = [];
  position: number = 0;
  adaptedImageSlider: any[] = [];
  links: string[] = [];
  style: string = '';
  activatePadding: boolean = false;
  maxWidth: string = '1500';
  title: string = '';
  titleSize: string = '';
  titleColor: string = '';
  fontWeight: string = '';
  nbrProductsPerLine: number = 4;
  subscription: Subscription;
  loading: boolean = true;
  allElementAnimation: string;
  textAnimation: string;
  itemsAnimation: string;
  products$: BehaviorSubject<IProductInterface[]> = new BehaviorSubject<IProductInterface[]>(null);
  currency$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  titleFontFamily: string;
  titleFontFamilyName: string;

  constructor(
    private dataService: DataService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private router: Router,
    private fontsService:FontsService,
    private commerceService: CommerceService
  ) {
  }

  ngOnInit() {
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "EcommerceComponent");
    });
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.itemsAnimation = this.data.animation.items != '' ? this.data.animation.items : undefined;
    }
    this.loading = false;
    this.title = this.data.title;
    this.categoriesFilter = this.data.categoriesFilter ? this.data.categoriesFilter : [];
    this.backgroundColor = this.data.backgroundColor;
    this.fontWeight = this.data.fontWeight;
    this.nbrProductsPerLine = this.data.nbrProductsPerLine ? this.data.nbrProductsPerLine : 4;
    this.titleColor = this.data.titleColor ? this.data.titleColor : this.dataService.getDefaultColor(this.backgroundColor);
    this.subscription = this.dataService.getSiteId().subscribe(siteId => {
      if (siteId)
        this.commerceService.getProducts(siteId, this.categoriesFilter).subscribe(products => {
          const prd = products.data.sort((a, b) => {
            if (a.order && b.order) {
              if (a.order > b.order) {
                return 1;
              }
              if (a.order < b.order) {
                return -1;
              }
              return 0;
            } else if (a.order) {
              return 1;
            } else if (b.order) {
              return 1;
            }
            return 0;
          });
          prd.forEach(element => {
            this.links.push('/shop/product/' + element.id + '/' + element.name.replace(/ /g, '-'))
          })
          this.products$.next(prd);
        });

      this.commerceService.getStoreCurrentSession(siteId).then(store => {
        if (store) {
          const cr = store.currency ? store.currency.toLocaleUpperCase() : 'usd';
          this.currency$.next((CURRENCIES.find(element => element.name.toLocaleLowerCase() === cr.toLocaleLowerCase())).code);
        }
      });
    });
    this.titleFontFamily = this.data.titleFontFamily ? this.data.titleFontFamily : '';
    if(this.titleFontFamily){
      this.fontsService.AddFont(this.titleFontFamily);
      this.titleFontFamilyName = this.titleFontFamily.replace(/\+/g, " ")
    }
  }
  isString(val): boolean { return typeof val === 'string'; }
  redirectToProductDetails(id: string, name: string) {
    this.googleAnalyticsService.FbEventEmitter('ViewProduct', 'Product name' + name, 'Product name' + name, 'ecommerce');
    this.router.navigate([]);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
